// Page Functions

var canBeLoaded = true,
    headerHeight;

window.PageFunctions = {
	
	setup: function() {
        this.loaded();
        this.eventListeners();
        this.checkScrollPosition();
        this.persistentUTMParams();
        this.preventDefaultOnHashLinks();
        this.backToTop();
        this.logo();
	},     

    logo: function() {

        const logoContainer = document.querySelector('.brand-col');
        const darkLogo      = document.querySelector('.header--logo_dark');
        const lightLogo     = document.querySelector('.header--logo_light');
        const sections      = document.querySelectorAll('main.main section, .footer-contact-cta');

        window.addEventListener('scroll', () => {
            const scrollPosition = window.scrollY;

            sections.forEach(section => {

                const sectionTop    = section.offsetTop - 110 - 55;
                const sectionBottom = sectionTop + section.offsetHeight;


                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {

                    let logo_type = section.getAttribute('data-logo');    

                    if (logo_type === 'white') {
                        darkLogo.style.opacity = '0';
                        lightLogo.style.opacity = '1';
                        
                    } else {
                        darkLogo.style.opacity = '1';
                        lightLogo.style.opacity = '0';
                    }
                }
            });
        });
    },

    backToTop: function() {

        let back_to_top_button = document.querySelector('.js--back-to-top');

        back_to_top_button.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // You can change this to 'auto' for instant scrolling
            });
        });

    },
    loaded: function() {
        document.addEventListener("DOMContentLoaded", function() {
            let body = document.querySelector('body');
            body.classList.add('js-loaded');
        });
    },
    preventDefaultOnHashLinks: function() {
        // Menu Trigger
        let links = document.querySelectorAll('a');
        links.forEach((el, index) => {
            el.addEventListener( 'click', function(e) {
                let target = e.currentTarget;
                let href   = target.getAttribute('href');
                if (href == '#') {
                    e.preventDefault();
                }
            } );
        });
    },
    persistentUTMParams: function() {
        let utm = {};
        let trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign'];

        if ('ad_tracking_stor_x' in Cookies.get()) {
            utm = JSON.parse(Cookies.get('ad_tracking_stor_x'));

            trackingKeys.map(value => {
                let trackingValue = '';

                if (value in utm) {
                    trackingValue = utm[value];
                }

                document.querySelector('[value="empty_' + value + '"]').value = trackingValue;
            });

            return;
        }

        let urlSearchParams = new URLSearchParams(window.location.search);
        let params = Object.fromEntries(urlSearchParams.entries());

        let setCookie = false;

        trackingKeys.map(value => {
            let trackingValue = '';

            if (value in params) {
                setCookie = true;
                trackingValue = params[value];
            }

            utm[value] = trackingValue;
            var value_item = document.querySelector('[value="empty_' + value + '"]');
            if ( value_item ) {
                value_item.value = trackingValue;
            }
        });

        if (setCookie) {
            Cookies.set('ad_tracking_stor_x', JSON.stringify(utm), { expires: 30 });
        }
    },

    eventListeners: function() {

        // Menu Trigger
        let menu_triggers = document.querySelectorAll('.js--menu_trigger');
        menu_triggers.forEach((el, index) => {
            el.addEventListener( 'click', window.PageFunctions.mobileMenu );
        });

        // Open Mobile Mega Navs
        let mobile_mega_links = document.querySelectorAll('.menus.mobile .menu-item-has-children > a');
        mobile_mega_links.forEach((el, index) => {
            el.addEventListener( 'click', window.PageFunctions.openMobileMegaNavs );
        });

        // Scroll To Anchor Links
        let anchor_links = document.querySelectorAll('main.main a[href^="#"]:not(.noscroll):not([data-lity])');
        anchor_links.forEach((el, index) => {
            el.addEventListener( 'click', window.PageFunctions.scrollToTopOfDivWithOffset );
        });

        // Shrink Header On Scroll
        window.addEventListener( 'scroll', window.PageFunctions.shrinkHeaderOnScroll );

        // Accordions
        let accordion_triggers = document.querySelectorAll('.js--accordion-trigger');
        accordion_triggers.forEach((el, index) => {
            el.addEventListener( 'click', window.PageFunctions.accordions );
        });

        // single social share
        let social_share_links = document.querySelectorAll('.single-post--social-link');
        social_share_links.forEach((el, index) => {
            el.addEventListener( 'click', window.PageFunctions.openShareWindow );
        });
        

    },

    openShareWindow: function(e) {
    
        e.preventDefault();
        e.stopPropagation();
        let target = e.currentTarget;
        let href = target.getAttribute('href');
        let windowHeight = window.innerHeight;
        let windowWidth = window.innerWidth;
        
        console.log(target);

        window.open(
            href,
            "sharingWindow",
            "height=450, width=550, top=" +
                ( windowHeight / 2 - 275) +
                ", left=" +
                ( windowWidth / 2 - 225) +
                ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
        );
    },

    mobileMenu: function(e) {

        e.preventDefault();
        
        let menu_open_class = 'menu-open';
        let body            = document.body;
        
        if (  window.helpers.hasClass( body, menu_open_class ) ) {
            window.helpers.removeClass( body, menu_open_class );
        } else {
            window.helpers.addClass( body, menu_open_class );
        }

    },

    openMobileMegaNavs: function(e) {
        e.preventDefault();

        let next   = window.helpers.next(e.currentTarget);
        let parent = window.helpers.parent(e.currentTarget);

        window.helpers.slideToggle(next, 500);
        window.helpers.toggleClass(parent, 'nav-item-open');

    },

    /**
     * Scroll to the top of a div with header offset
     */
    scrollToTopOfDivWithOffset: function(e) {

        e.preventDefault();

        let href   = e.target.getAttribute('href');

        if (href != '#') {
            let target = href.replace("#", "");
            
            let element         = document.getElementById( target );
            let headerOffset    = 120;
            let elementPosition = element.getBoundingClientRect().top;
            let offsetPosition  = elementPosition + window.pageYOffset - headerOffset;
              
            window.scrollTo({
                 top: offsetPosition,
                 behavior: "smooth"
            });
        }

    },

    /**
     *  Add shrink class to header on scroll
     */
    shrinkHeaderOnScroll: function() {

        let scroll_position = window.helpers.scrollTop(window);
        let threshold       = 50;
        let body            = document.body;

        if ( scroll_position > threshold ) {
            window.helpers.addClass(body, 'shrink');
        } else {
            window.helpers.removeClass(body, 'shrink');
        }

    },
    checkScrollPosition: function() {

        let scroll_position = window.helpers.scrollTop(window);
        let body            = document.body;

        if (scroll_position > 0) {
            window.helpers.addClass( body, 'shrink' )
        }
    },
    /**
     * Accordions
     */
    accordions: function(e) {
    
        e.preventDefault();

        let target = e.currentTarget;
        let parent = window.helpers.parent(target);
        let next   = window.helpers.next(target);

        window.helpers.toggleClass(parent, 'open');
        
    }

};





